import React, { useEffect, useState, useCallback } from 'react';

import { retrieveEligibleClients, viewClient } from '../../../../services/ClientService';

import Modal from '../../../common/modal/Modal';
import { Table } from '../../../common/table/Table';
import { BackButton } from '../../../common/button/back-button/BackButton';
import { LinkClientToStudy } from './LinkClientToStudy';

import './ParticipantsLinkNew.css';

export const ParticipantsLinkNew = ({
  context,
  navigateTo,
  navigateToWith,
  navigateBack,
  setSpinnerText,
  showToaster,
  toolTipsEnabled,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [client, setClient] = useState(false);
  const [study, setStudy] = useState(false);

  const retrieveClients = useCallback(async () => {
    setSpinnerText('Retrieving Clients');
    const viewEligibleClientRequest = {
      coEnrollmentAllowedStudy: context?.additionalContext?.coEnrolmentAllowed,
    };
    const [data, error] = await retrieveEligibleClients(context.username, viewEligibleClientRequest);
    if (data) {
      if (data.responseStatus === 'Success') {
        setSearchResults(data.clients);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  }, [context.username, setSpinnerText, showToaster, context?.additionalContext?.coEnrolmentAllowed]);

  useEffect(() => {
    retrieveClients();
    if (context.canNavigateBack && context.navigateContext) {
      setStudy(context.navigateContext);
    }
  }, [context.canNavigateBack, context.navigateContext, retrieveClients]);

  const handleBack = () => {
    navigateBack();
  };

  const handleRowClick = async (selectedClient) => {
    setSpinnerText('Retrieving Client');
    const [data, error] = await viewClient(context.username, selectedClient.externalReference);
    if (data) {
      if (data.responseStatus === 'Success') {
        setClient(data.clientVO);
        showToaster({
          responseStatus: 'Success',
          responseMessage: 'Client Information Retrieved',
        });
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className="clients-create-header-container">
        <BackButton onClick={handleBack} />
        <h2>Link Client to a Study</h2>
      </div>

      {searchResults && (
        <div className="participants-link-new-table">
          <Table
            tableData={searchResults}
            hiddenColumns={['externalReference', 'created', 'isDeleted', 'lastModified', 'clientConsents']}
            onRowClick={handleRowClick}
            maxRowCount={10}
            tableTitle={'Clients'}
            excludedFilterColumns={['firstName', 'lastName', 'idNumber', 'passportNumber']}
            searchEnabled
            filterEnabled
          />
          {isModalOpen && (
            <Modal
              closeModal={closeModal}
              setIsModalOpen={setIsModalOpen}
              hideButton={true}
              headerTitle={'Link Client to Study'}
              width={'650px'}
              justifyContent={'center'}
            >
              <LinkClientToStudy
                client={client}
                study={study}
                closeModal={closeModal}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                context={context}
                navigateTo={navigateTo}
                navigateToWith={navigateToWith}
                toolTipsEnabled={toolTipsEnabled}
              />
            </Modal>
          )}
        </div>
      )}
    </div>
  );
};
